export default __webpack_public_path__ + "static/media/featured-in-7.86157aab.png";